import { searchLocation } from "apis";
import {
  FilterBar,
  FilterDateRange,
  FilterMultiSelect,
  FilterTimeRange,
} from "components/commons";
import { useApi, useMount } from "hooks";
import { allLocationRequest, location } from "mappers";
import React, { useCallback, useMemo } from "react";
import { mapObject, mapObjectsToSelect } from "services";
import lang from "translations";

const StocktakeFilter = ({ filterState, requestState, modifyFilter, clearFilter, onApply }) => {
  const {
    request: searchLocationRequest,
    loading: loadingLocations,
    mappedData: locations,
  } = useApi({
    api: searchLocation,
    isArray: true,
    mapper: location,
    handleOwnError: true,
  });

  useMount(() => {
    fetchLocationRequest(requestState);
  });

  const fetchLocationRequest = useCallback(
    (requestState) => {
      searchLocationRequest(mapObject({ ...requestState }, allLocationRequest));
    },
    [searchLocationRequest]
  );

  const applyFilterCb = useCallback(
    async (searchKey) => {
      await onApply(searchKey);
    },
    [onApply]
  );

  const clearFilterCb = useCallback(() => {
    clearFilter();
  }, [clearFilter]);

  const locationOptions = useMemo(() => {
    let sorted = locations
      .map((item) => {
        item.name = item.name.trim();
        return item;
      })
      .sort((a, b) => (a.name > b.name ? 1 : -1));
    let mapped = mapObjectsToSelect(sorted, { textKey: "name", valueKey: "id" });
    return mapped;
  }, [locations]);

  const statusOptions = useMemo(() => {
    return [
      {
        text: lang.inProgress,
        value: "IN_PROGRESS",
      },
      {
        text: lang.forApproval,
        value: "FOR_APPROVAL",
      },
      {
        text: lang.completed,
        value: "COMPLETED",
      },
      {
        text: lang.void,
        value: "VOID",
      },
    ];
  }, []);

  const changeDateRangeCb = useCallback(
    (name, value) => {
      const { requestState } = modifyFilter(name, { value });
      fetchLocationRequest(requestState);
    },
    [fetchLocationRequest, modifyFilter]
  );

  return (
    <FilterBar
      placeholder={lang.searchForStocktakeId}
      className="mb-lg"
      onApply={applyFilterCb}
      onClear={clearFilterCb}
      filterState={filterState}
    >
      <FilterDateRange
        id="dateRange"
        label={lang.dates}
        value={filterState.dateRange}
        onChange={(value) => changeDateRangeCb("dateRange", value)}
      />
      <FilterTimeRange
        id="timeRange"
        label={lang.time}
        value={filterState.dateRange}
        onChange={(value) => modifyFilter("dateRange", { value })}
      />
      <FilterMultiSelect
        id="locations"
        label={lang.outlet}
        allLabel={lang.allLocations}
        emptyLabel={lang.noLocationAvailable}
        disableWhenEmpty={false}
        loading={loadingLocations}
        options={locationOptions}
        value={filterState.locations}
        onChange={(value) => modifyFilter("locations", { value })}
      />
      <FilterMultiSelect
        id="status"
        align="right"
        label={lang.status}
        allLabel={lang.allStatus}
        options={statusOptions}
        value={filterState.status}
        onChange={(value) => modifyFilter("status", { value })}
      />
    </FilterBar>
  );
};

export default StocktakeFilter;
